import React, { useState } from 'react';
import { FormRenderProps } from '@progress/kendo-react-form';
import { DataType } from '../../../config/Constants';
import { FieldBox, FieldDataBox } from '../../layout/boxes/FieldBox';
import { Row, Col } from 'react-bootstrap';
import { IRequestAccessPageProps } from '../../services/GraphQLTypes';
import { RequestAccessPageResources as Resources } from '../../../config/Resources';
import { IFormPageProps } from '../../layout/panels/ViewPanel';
import { EntityType } from '../../services/GraphQLModel';
import { FormPanel } from '../../layout/panels/FormPanel';
import { RootState } from '../../../store/reducer/rootReducer';
import { useSelector } from 'react-redux';
import { GET_MAM_SELF_REQUESTABLE_GROUPS_BY_COUNTRY } from '../../services/GraphQLMatrixAccessManager';

export function RequestAccessPageFormPage(props: IFormPageProps<IRequestAccessPageProps>): React.ReactElement {
  const selectSecurity = (state: RootState) => state.security;
  const currentSecurity = useSelector(selectSecurity);
  const loggedInEmail = currentSecurity?.userInfo?.userPrincipalName ?? "";
  const parent = (props.initialValues as any)?.parent;
  const initialValues = {
    ...props.initialValues,
    requestor: loggedInEmail,
    appInstance: parent?.appInstance ?? ''
  };
  const [groupHint, setGroupHint] = useState('');
  const handleGroupChange = (event: any) => {
    const selectedValue = event.target?.value || event.value;
    if (selectedValue && selectedValue.description) {
      setGroupHint(selectedValue.description);
    } else {
      setGroupHint('');
    }
  };

  const formContent = (formRenderProps: FormRenderProps): React.ReactElement => {
    return (
      <>
        <Row>
          <Col>
            <FieldBox
              field={'requestor'}
              title={Resources.Requestor}
              disabled={true}  
            />
          </Col>          
        </Row>
        <Row>
          <Col>
            <FieldBox
              field={'appInstance'}
              title={Resources.ApplicationInstance}
              required={true}
              disabled={true}              
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FieldDataBox
              field={'group'}
              title={Resources.Group}
              placeholder={Resources.Group_Placeholder}
              type={DataType.ComboBox}
              required={true}
              disabled={!formRenderProps.valueGetter('appInstance')}
              variables={{
                country: formRenderProps.valueGetter('appInstance')
              }}
              dataSource={GET_MAM_SELF_REQUESTABLE_GROUPS_BY_COUNTRY}
              mutateData={(data: any[]) =>
                data.map(g => ({
                  id: g.GroupId,
                  display: g.GroupName,
                  description: g.Description
                }))
              }
              hint={groupHint ? `Description: ${groupHint}` : ''}
              onChange={handleGroupChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <FieldBox
              field={'comment'}
              type={DataType.AreaText}
              title={Resources.Comment}
              placeholder={Resources.Comment_Placeholder}
              required={true}
            />
          </Col>
        </Row>
      </>
    );
  };
  return <FormPanel {...props} type={EntityType.AccessRequest} getElements={formContent} initialValues={initialValues}/>;
}